import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dff1a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component patientinfo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title__text" }, "환자 정보", -1))
const _hoisted_3 = { class: "table__box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "중환자실"),
  /*#__PURE__*/_createElementVNode("div", null, "환자번호"),
  /*#__PURE__*/_createElementVNode("div", null, "이름"),
  /*#__PURE__*/_createElementVNode("div", null, "나이"),
  /*#__PURE__*/_createElementVNode("div", null, "키"),
  /*#__PURE__*/_createElementVNode("div", null, "몸무게"),
  /*#__PURE__*/_createElementVNode("div", null, "성별")
], -1))
const _hoisted_5 = { class: "table__body" }
const _hoisted_6 = { class: "table__tr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (_ctx.patientInfo.WD_DEPT_CD)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.WD_DEPT_CD), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.PT_NO)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.PT_NO), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.PT_NM)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.PT_NM), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.AGE)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.AGE), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.HEIGHT)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.HEIGHT), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.WEIGHT)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.WEIGHT), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ]),
          _createElementVNode("div", null, [
            (_ctx.patientInfo.SEX_TP_CD)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.SEX_TP_CD), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ])
        ])
      ])
    ])
  ]))
}